import { AxiosInstanceType } from '../utils/axios';

export class Service {
  axiosInstance: AxiosInstanceType;

  constructor(axiosInstance: AxiosInstanceType) {
    this.axiosInstance = axiosInstance;
  }
}
